/*

BUTTON COMPONENT
----------------

Default Value
-------------

  label,
  width = "20rem",
  height = "3.8rem",
  borderRadius = "0.9rem",
  backgroundColor = "#fff",
  theme=dark/light
  size = large/small
  color = color, 
  borderColor = "#fff",
  disabled = false,
  onClick,
  icon: Icon,
  isIcon = false, if icon is present in button

*/
import React, { useState } from "react";
import { useLocation } from "react-router";
import Loader from "../Loader/Loader";
import { useSelector } from "react-redux";
import classes from "./Button.module.scss";
import RoleMenuChek from "../../../hoc/RoleMenuCheck";

const Button = ({
  label,
  width = "20",
  height = "3.8",
  borderRadius = "0.8",
  borderSize = "0.1",
  backgroundColor = "#fff",
  color = JSON.parse(localStorage.getItem("themeData"))?.CustomData
    ?.PrimaryColor1 || "#d31b61",
  borderColor = color,
  disabled = false,
  onClick,
  icon: Icon,
  isHover = false,
  hoverColor,
  dark = false,
  light = false,
  large = false,
  small = false,
  type = "button",
  path,
  isReportBtn = false,
  loading = false,
  justifyContent = "center",
  flexDirection = "row",
  fontWeight = "bold",
  name,
  feature
}) => {
  const commonState = useSelector((state) => state.commonReducer);
  const { colors } = commonState;
  const [hoverState, sethoverState] = useState(false);
  const location = useLocation();
  return (
    <RoleMenuChek feature={feature}>
      <button
        type={type}
        onClick={onClick}
        className={classes.primaryButton}
        disabled={disabled || loading}
        onMouseEnter={() => {
          if (isHover) sethoverState(true);
        }}
        onMouseLeave={() => {
          if (isHover) sethoverState(false);
        }}
        style={{
          color:
            path === location.pathname && isReportBtn
              ? "#fff"
              : loading
              ? color
              : disabled && light
              ? "#B9B9B9"
              : disabled && dark
              ? "#707070"
              : hoverState
              ? "#fff"
              : dark
              ? "#fff"
              : color,
          backgroundColor:
            path === location.pathname && isReportBtn
              ? colors.theme
              : loading
              ? "#f4f4f4"
              : disabled && dark
              ? "#b9b9b9"
              : hoverState && hoverColor
              ? hoverColor
              : hoverState
              ? color
              : large || light
              ? "#fff"
              : dark
              ? color
              : backgroundColor,
          border: `${borderSize}rem solid ${
            loading
              ? borderColor
              : disabled && light
              ? "#B9B9B9"
              : hoverState || (disabled && dark)
              ? "transparent"
              : large || light
              ? color
              : dark
              ? color
              : borderColor
          } `,
          borderRadius: large
            ? "0.9rem"
            : small
            ? "0.7rem"
            : borderRadius + "rem",
          width: large ? "20rem" : small ? "14.5rem" : width + "rem",
          height: large ? "3.8rem" : small ? "4.9rem" : height + "rem",
          cursor: disabled || loading ? "not-allowed" : "pointer",
          justifyContent: justifyContent,
          flexDirection: flexDirection,
          fontWeight: fontWeight,
        }}
      >
        {loading ? (
          <Loader />
        ) : (
          Icon && (
            <Icon
              fill={
                path === location.pathname && isReportBtn
                  ? "#fff"
                  : light && disabled
                  ? "#B9B9B9"
                  : hoverState
                  ? "#fff"
                  : color
              }
            />
          )
        )}
        {label}
      </button>
    </RoleMenuChek>
  );
};

export default Button;
